export class SystemInfoConsts {
  static readonly notificationDurationTime = 3000;
  static readonly httpStatusRadiusCUD = 422;
  static readonly refreshRadiusInformationDelay = 5000;
  static readonly primaryLigthHoverColor = '#87d35d';
}
